import { useMutation } from 'react-query'
import { get } from 'framework/api/http'

interface getPartnerByIdInterface {
  id?: string
}

export const useGetPartnerById = () => {
  const mutate = useMutation(({ id }: getPartnerByIdInterface) => {
    return get(`/Partner/${id}`)
  })

  return mutate
}

export default useGetPartnerById
